module.exports = __webpack_public_path__ + "static/media/android-plain.ed7cc52b.svg";